import React from "react";
import { Phone, Mail, MapPin } from "lucide-react";
import { SITE, NAV } from "@/lib/site";

export const Footer = () => {
  return (
    <footer
      data-testid="site-footer"
      className="relative bg-brand-ink border-t border-white/5"
    >
      <div className="max-w-7xl mx-auto px-4 md:px-8 py-16 grid md:grid-cols-12 gap-10">
        <div className="md:col-span-5">
          <div className="flex items-center gap-3">
            <img
              src={SITE.logo}
              alt="Renderwall Ltd"
              className="h-14 w-14 object-cover rounded-sm ring-1 ring-white/10"
            />
            <div>
              <div className="font-serif text-2xl text-white tracking-wide">
                RENDERWALL
              </div>
              <div className="text-[10px] uppercase tracking-[0.25em] text-brand-gold/90">
                Plastering & Rendering Projects
              </div>
            </div>
          </div>
          <p className="mt-6 text-white/65 max-w-md leading-relaxed">
            Renderwall Ltd is a Hampshire-based rendering, plastering and
            drylining contractor delivering domestic and commercial projects
            across the South East.
          </p>
        </div>

        <div className="md:col-span-3">
          <div className="text-xs uppercase tracking-[0.22em] text-brand-gold/90">
            Navigate
          </div>
          <ul className="mt-5 space-y-3">
            {NAV.map((n) => (
              <li key={n.id}>
                <a
                  href={n.href}
                  data-testid={`footer-link-${n.id}`}
                  className="text-white/70 hover:text-brand-gold transition-colors"
                >
                  {n.label}
                </a>
              </li>
            ))}
          </ul>
        </div>

        <div className="md:col-span-4">
          <div className="text-xs uppercase tracking-[0.22em] text-brand-gold/90">
            Get in touch
          </div>
          <ul className="mt-5 space-y-4">
            <li>
              <a
                href={`tel:${SITE.phoneRaw}`}
                className="inline-flex items-center gap-3 text-white/80 hover:text-brand-gold transition-colors"
              >
                <Phone className="h-4 w-4 text-brand-gold" /> {SITE.phone}
              </a>
            </li>
            <li>
              <a
                href={`mailto:${SITE.email}`}
                className="inline-flex items-center gap-3 text-white/80 hover:text-brand-gold transition-colors break-all"
              >
                <Mail className="h-4 w-4 text-brand-gold" /> {SITE.email}
              </a>
            </li>
            <li className="inline-flex items-center gap-3 text-white/80">
              <MapPin className="h-4 w-4 text-brand-gold" /> {SITE.area}
            </li>
          </ul>
        </div>
      </div>
      <div className="divider-gold" />
      <div className="max-w-7xl mx-auto px-4 md:px-8 py-6 flex flex-col sm:flex-row gap-3 justify-between text-xs text-white/50">
        <div>
          © {new Date().getFullYear()} Renderwall Ltd. All rights reserved.
        </div>
        <div className="uppercase tracking-[0.22em]">
          Hampshire · South East · UK
        </div>
      </div>
    </footer>
  );
};
